import { isDevelopmentEnvironment } from "@/lib/env";
import { isNewScheduledOrderCycleEnabled } from "@/features/newScheduledOrderCycleFeature";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const EXAM_SHIPMENT_DISTRIBUTION_DEV_ONLY = true;

export let isExamShipmentDistributionEnabled = false;

// Tela "Distribuição de Remessas" (shipment_blocks de exams_sku_composition por ciclo e botão "Redistribuir entregas").
// Depende do novo fluxo de pedidos programados (ciclos 2027+). Comente a linha abaixo para desativar no frontend.
// Mantenha em sincronia com Features/ExamShipmentDistributionFeature.cs do backend.
isExamShipmentDistributionEnabled =
  isNewScheduledOrderCycleEnabled && (!EXAM_SHIPMENT_DISTRIBUTION_DEV_ONLY || isDevelopmentEnvironment);
